@if (uiRoleManagerService.canI(eRoleActions.EDIT_ITEM)) {
  <form (ngSubmit)="onLink()"
    [formGroup]="form"
    class="mb-4"
    >
    <h4>{{'ITEM.DETAIL.LINK_NEW_ITEM_TO_LOOKBOOK' | translate}}</h4>
    <div class="d-flex align-items-center gap-2">
      <mat-form-field appearance="outline"
        class="form-field-condensed">
        <mat-label>{{'COMMON.LABEL.INVENTORY' | translate}}</mat-label>
        <input matInput
          formControlName="inventory">
      </mat-form-field>
      <button mat-raised-button
        color="primary"
        [disabled]="!form.valid"
        type="submit">
        {{'COMMON.LABEL.CREATE_LINK' | translate}}
      </button>
    </div>
  </form>
}

@if (selectedItem.lookbooks_to?.length) {
  <div class="items-list"
    >
    <h4>{{'ITEM.DETAIL.LINKED_LOOKBOOKS' | translate}}</h4>
    @for (item of selectedItem.lookbooks_to; track item) {
      <mpa-linked-item-row
        [item]="item"
      (removeLink)="onRemoveLink($event)"></mpa-linked-item-row>
    }
  </div>
}

@if (selectedItem.lookbooks_from?.length) {
  <div class="items-list mt-4"
    >
    <h4>{{'ITEM.DETAIL.LINKED_ITEMS' | translate}}</h4>
    @for (item of selectedItem.lookbooks_from; track item) {
      <mpa-linked-item-row
        [item]="item"
      (removeLink)="onRemoveLink($event)"></mpa-linked-item-row>
    }
  </div>
}

@if (!selectedItem.lookbooks_to?.length && !selectedItem.lookbooks_from?.length) {
  <h4>{{'ITEM.DETAIL.EMPTY_ITEM_LINKED_LOOKBOOKS' | translate}}</h4>
}